import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    Containers,
} from 'app/Apps/ContainerManagement/Containers/containers.types'

const config: SkyNetTableConfig<keyof Containers> = {
    name: 'ContainerSelection.WrongPairings',
    tabs: [{
        name: 'Wrong Pairings',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'serialNumber',
                width: '130px',
                labelKey: 'SERIAL_NUMBER',
            },
            {
                name: 'containerTypeContainerModel',
                width: '200px',
                labelKey: 'CONTAINER_MODEL',
            },
            {
                name: 'currentOrderOrderNumber',
                labelKey: 'CURRENT_ORDER',
            },
            {
                name: 'lastMeasuredOnUtcInternal',
                componentName: 'Age',
                width: '150px',
                sorting: false,
                labelKey: 'INTERNAL_DATA_AGE',
            },
            {
                name: 'lastMeasuredOnUtcAmbient',
                componentName: 'Age',
                width: '150px',
                sorting: false,
                labelKey: 'AMBIENT_DATA_AGE',
            },
            {
                name: 'currentInternalLocationLocationName',
                labelKey: 'INTERNAL_LOGGER_LOCATION',
            },
            {
                name: 'currentAmbientLocationLocationName',
                labelKey: 'AMBIENT_LOGGER_LOCATION',
            },
        ],
    }],
}

export default config
